__turbopack_context__.v({
  "active": "BlogCard-module__HzjtUG__active",
  "authorName": "BlogCard-module__HzjtUG__authorName",
  "blogCard": "BlogCard-module__HzjtUG__blogCard",
  "categoryBadge": "BlogCard-module__HzjtUG__categoryBadge",
  "darkOverlay": "BlogCard-module__HzjtUG__darkOverlay",
  "date": "BlogCard-module__HzjtUG__date",
  "disabled": "BlogCard-module__HzjtUG__disabled",
  "excerpt": "BlogCard-module__HzjtUG__excerpt",
  "fadeIn": "BlogCard-module__HzjtUG__fadeIn",
  "featuredBadge": "BlogCard-module__HzjtUG__featuredBadge",
  "featuredCard": "BlogCard-module__HzjtUG__featuredCard",
  "featuredCategory": "BlogCard-module__HzjtUG__featuredCategory",
  "featuredImage": "BlogCard-module__HzjtUG__featuredImage",
  "featuredImageWrapper": "BlogCard-module__HzjtUG__featuredImageWrapper",
  "featuredMainCard": "BlogCard-module__HzjtUG__featuredMainCard",
  "featuredMainImage": "BlogCard-module__HzjtUG__featuredMainImage",
  "featuredMainImageWrapper": "BlogCard-module__HzjtUG__featuredMainImageWrapper",
  "featuredMainTitle": "BlogCard-module__HzjtUG__featuredMainTitle",
  "featuredMeta": "BlogCard-module__HzjtUG__featuredMeta",
  "featuredOverlay": "BlogCard-module__HzjtUG__featuredOverlay",
  "featuredSection": "BlogCard-module__HzjtUG__featuredSection",
  "featuredText": "BlogCard-module__HzjtUG__featuredText",
  "featuredTextBlock": "BlogCard-module__HzjtUG__featuredTextBlock",
  "featuredTitle": "BlogCard-module__HzjtUG__featuredTitle",
  "listCategory": "BlogCard-module__HzjtUG__listCategory",
  "listItem": "BlogCard-module__HzjtUG__listItem",
  "listMeta": "BlogCard-module__HzjtUG__listMeta",
  "listThumb": "BlogCard-module__HzjtUG__listThumb",
  "metaInfo": "BlogCard-module__HzjtUG__metaInfo",
  "overlay": "BlogCard-module__HzjtUG__overlay",
  "overlayText": "BlogCard-module__HzjtUG__overlayText",
  "page-item": "BlogCard-module__HzjtUG__page-item",
  "page-link": "BlogCard-module__HzjtUG__page-link",
  "pageItem": "BlogCard-module__HzjtUG__pageItem",
  "pagination": "BlogCard-module__HzjtUG__pagination",
  "popularLink": "BlogCard-module__HzjtUG__popularLink",
  "popularRank": "BlogCard-module__HzjtUG__popularRank",
  "rightSideCard": "BlogCard-module__HzjtUG__rightSideCard",
  "rightSideContent": "BlogCard-module__HzjtUG__rightSideContent",
  "rightSideHeader": "BlogCard-module__HzjtUG__rightSideHeader",
  "rightSideImage": "BlogCard-module__HzjtUG__rightSideImage",
  "rightSideItem": "BlogCard-module__HzjtUG__rightSideItem",
  "rightSideMeta": "BlogCard-module__HzjtUG__rightSideMeta",
  "rightSideScroll": "BlogCard-module__HzjtUG__rightSideScroll",
  "rightSideTitle": "BlogCard-module__HzjtUG__rightSideTitle",
  "sidebarBadge": "BlogCard-module__HzjtUG__sidebarBadge",
  "sidebarCard": "BlogCard-module__HzjtUG__sidebarCard",
  "sidebarCategoryLink": "BlogCard-module__HzjtUG__sidebarCategoryLink",
  "sidebarHeader": "BlogCard-module__HzjtUG__sidebarHeader",
  "sidebarListItem": "BlogCard-module__HzjtUG__sidebarListItem",
  "tagBadge": "BlogCard-module__HzjtUG__tagBadge",
  "text-muted": "BlogCard-module__HzjtUG__text-muted",
  "thumbnail": "BlogCard-module__HzjtUG__thumbnail",
  "thumbnailWrapper": "BlogCard-module__HzjtUG__thumbnailWrapper",
  "title": "BlogCard-module__HzjtUG__title",
  "titleSmall": "BlogCard-module__HzjtUG__titleSmall",
});
